import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./Components/BodyComp/adminpanel";
import Login from "./Components/LoginComp/login";
import PrivateRoute from "./PrivateRoute";
import { auth, db } from "./Components/FirebaseComp/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";




const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />

   
        <Route
          path="/adminpanel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <AdminPanel />
            </PrivateRoute>
          }
        />










      </Routes>
   
    </Router>

    
  );
};

export default App;
